import MuiButton, { type ButtonProps } from "@mui/material/Button";
import { twMerge } from "tailwind-merge";

const BUTTON_VARIANTS = {
  primary: "bg-primary text-white hover:bg-primary/90",
  secondary: "bg-secondary text-white hover:bg-secondary/90",
  dark: "bg-accent text-white hover:bg-accent/90",
  neutral: "bg-white text-red-600 border border-gray-300 hover:bg-gray-50",
  ghost: "bg-transparent text-gray-400 hover:bg-gray-100 hover:text-gray-600",
  muted: "bg-muted hover:bg-gray-200",
  danger: "bg-red-600 text-white hover:bg-red-700",
} as const;
const BUTTON_SIZES = {
  sm: "w-24 sm:w-32 h-fit py-2 px-4",
  md: "w-32 sm:w-48 h-fit py-2 px-6",
  lg: "w-40 sm:w-64 lg:w-72 h-fit py-3 px-8",
  xl: "w-48 sm:w-80 lg:w-96 h-fit py-4 px-10",
  full: "w-full h-fit py-2 px-6",
  auto: "h-fit py-2 px-8",
} as const;

type CustomButtonProps = Omit<ButtonProps, "size"> & {
  children: React.ReactNode;
  className?: string;
  customVariant?:
    | "primary"
    | "secondary"
    | "dark"
    | "neutral"
    | "ghost"
    | "muted"
    | "danger";
  size?: "sm" | "md" | "lg" | "full" | "auto";
  type?: "button" | "submit" | "reset";
  startIcon?: React.ReactNode;
  onClick?: () => void;
};

function Button({
  children,
  className = "",
  customVariant = "primary",
  size = "auto",
  startIcon,
  onClick,
  type = "button",
}: CustomButtonProps) {
  const mergedClasses = twMerge(
    "rounded-full font-sans normal-case z-10",
    BUTTON_VARIANTS[customVariant],
    BUTTON_SIZES[size],
    className,
  );

  return (
    <MuiButton
      className={mergedClasses}
      startIcon={startIcon}
      onClick={onClick}
      type={type}
    >
      {children}
    </MuiButton>
  );
}

export default Button;
